import insertSxSV2IntoDomHelper from 'owa-attachment-select-actions/lib/utils/insertSxSV2IntoDomHelper';
import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SxS" */ './lazyIndex');
});
var lazyInsertSxSV2IntoDomIfNeeded = new LazyAction(lazyModule, function (m) { return m.insertSxSV2IntoDomIfNeeded; });
insertSxSV2IntoDomHelper.register(lazyInsertSxSV2IntoDomIfNeeded.importAndExecute);
//# sourceMappingURL=index.js.map